var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 325.27 286.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daa79d;}.cls-2{fill:#6f1132;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy",
    "data-name": "Layer 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183,10.6a10.6,10.6,0,1,1,10.6,10.6A10.59,10.59,0,0,1,183,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.67,104.42a10.6,10.6,0,1,0,10.6,10.6A10.6,10.6,0,0,0,314.67,104.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.76,109.11a10.6,10.6,0,1,0,10.59,10.59A10.59,10.59,0,0,0,126.76,109.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70,
    cy: 153.13,
    r: 10.6,
    transform: "translate(-33.31 20.18) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 126.76,
    cy: 174.33,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.73,147a10.6,10.6,0,1,0-10.6,10.6A10.6,10.6,0,0,0,122.73,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.52,60.16a10.6,10.6,0,1,0-10.6-10.6A10.6,10.6,0,0,0,176.52,60.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.75,241.5a10.6,10.6,0,1,0,10.6,10.6A10.6,10.6,0,0,0,300.75,241.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.07,192.33a10.6,10.6,0,1,0,10.6,10.6A10.6,10.6,0,0,0,304.07,192.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.12,
    cy: 213.53,
    r: 10.6,
    transform: "translate(-48.71 8.73) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 221.32,
    cy: 125.62,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.6,
    cy: 262.7,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 214.81,
    cy: 202.93,
    r: 10.6,
    transform: "translate(-54.88 323.73) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.42,
    cy: 234.49,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.81,98.75a6,6,0,0,0,2.27-5.51,40.49,40.49,0,0,1,2.35-17.51c4.32-11.31,13.85-18.12,28.32-20.23A6,6,0,1,0,147,43.62c-33.24,4.86-39.82,28.94-40.87,42.27a95.9,95.9,0,0,0-28.08-3c-18.57.93-43.92,8.64-59.23,40.06s-6.31,54.72,4,68.67a81.22,81.22,0,0,0,25.88,22.5,6.08,6.08,0,0,0,2.7.64,6,6,0,0,0,2.73-11.35c-2-1-48.66-25.59-24.48-75.21,24.34-49.95,78-29.53,80.3-28.64A6,6,0,0,0,115.81,98.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.16,176.29a6,6,0,0,0-9.73,7c1.31,1.83,31.51,45.05-12.72,78.06C230.31,270.62,218.4,274,207.63,274c-27.95,0-48.26-22.65-49.42-24A6,6,0,0,0,148,251.93a40.7,40.7,0,0,1-10.11,14.49c-9,8.07-20.61,9.75-34.45,5a6,6,0,0,0-3.9,11.35,56.79,56.79,0,0,0,18.48,3.34c20.11,0,31.7-13.24,37.23-22.17a95.79,95.79,0,0,0,23.59,15.51c16.93,7.68,43,12.45,71-8.45s30.7-45.74,28-62.84A81.08,81.08,0,0,0,265.16,176.29Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDust);
export default __webpack_public_path__ + "static/media/dust.db704361ff3bd954e2fab1a23f061a37.svg";
export { ForwardRef as ReactComponent };